export function nullableNumber(input: string) {
	if (input === null) {
		return null;
	}
	const inputAsNumber = Number(input);
	return inputAsNumber === Number.NaN ? null : inputAsNumber;
}
